module.exports = __webpack_public_path__ + "static/defaultaction-97da53a69f4605544dcb1fae979ecbc7.png";